import { useViewData } from "../view-data";
import { useViewModel } from "../view-model";
import { useCancelOptionPmsItem } from "./use-cancel-option-pms-item";

import type * as Repository from "../../../_repository";

type Props = {
	hotelID: string;
	// 検索日
	searchDate: string;
	// オプションリスト
	optionPmsActiveListQueryData: Repository.Query.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
	// オプションカラーリスト
	optionPmsColorListQueryData: Repository.Query.QueryData.OptionPmsColorListQueryData;
};

export const useInitialized = ({
	hotelID,
	searchDate,
	optionPmsActiveListQueryData,
	optionPmsColorListQueryData,
}: Props) => {
	/**
	 * ViewModel の生成
	 */
	const {
		//
		viewModel,
		// オプションの選択
		onSetCardIDOfOption,
		// オプションの選択解除
		onClearCardIDOfOption,
	} = useViewModel();

	/**
	 * ViewData の生成
	 */
	const { viewData } = useViewData({
		viewModel,
		searchDate,
		optionPmsActiveListQueryData,
		optionPmsColorListQueryData,
	});

	const {
		// オプションのキャンセル
		onCancelOptionPmsItem,
	} = useCancelOptionPmsItem({ hotelID });

	return {
		// readonly
		viewData,
		// changeable
		// オプションの選択
		onSetCardIDOfOption,
		// オプションの選択解除
		onClearCardIDOfOption,
		// mutable
		// オプションのキャンセル
		onCancelOptionPmsItem,
	};
};
